import React from "react";
import { Tooltip } from "@mui/material";

export const withButtonTooltip = (title: string | undefined, button: React.ReactElement) => {
  if (!title) {
    return button;
  }
  return (
    <Tooltip title={title} arrow>
      <span>{button}</span>
    </Tooltip>
  );
};

export default withButtonTooltip;
